import { AlertCircle } from 'lucide-react';
import { ApiError } from '@/lib/envelope';

interface ErrorStateProps {
  error: unknown;
  onRetry?: () => void;
}

export function ErrorState({ error, onRetry }: ErrorStateProps): JSX.Element {
  const code = error instanceof ApiError ? error.code : 'ERROR';
  const message = error instanceof Error ? error.message : 'Errore inatteso';

  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-md border border-border bg-card py-10 text-center">
      <AlertCircle className="h-6 w-6 text-state-danger" />
      <div className="text-sm font-medium text-foreground">{message}</div>
      <div className="font-mono text-xs text-muted-foreground">{code}</div>
      {onRetry ? (
        // eslint-disable-next-line fe-gov/no-raw-html-primitives -- intentional: inline retry button in intermediari ErrorState (bg-secondary + rounded-md); web-intermediari has no PillButton primitive yet, and secondary+rounded-md does not map to backoffice PillButton variants
        <button
          type="button"
          onClick={onRetry}
          className="mt-2 rounded-md border border-border bg-secondary px-3 py-1.5 text-sm text-secondary-foreground transition-colors hover:bg-muted"
        >
          Riprova
        </button>
      ) : null}
    </div>
  );
}
